import React, { useState, useEffect } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
// import PaginationOld from './PaginationOld';
import {db} from '../../firebase'
import ScrollToTop from "react-scroll-to-top";


import ReactPlayer from "react-player";

function YoutubeV() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
      const [showPerPage, setShowPerPage] = useState(33);
      const [pagination, setPagination] =useState({
          start: 0,
          end: showPerPage,
      });
  
      const onPaginationChange = (start,  end) =>{
          setPagination({start: start, end: end});
      };
      const [searchTerm, setsearchTerm] = useState("");
      const [videogallery, setVideogallery] = useState([])
      const navigate = useNavigate()
  
      const videogalleryCollectionRef = collection(db, "YOUTUBE Video");
      useEffect(() => {
  
          const getVideogallery = async () => {
              const data = await getDocs(videogalleryCollectionRef);
              setVideogallery(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
          }
  
          getVideogallery()
      }, [])
    return (
      
<>




<ScrollToTop smooth top="100" color="maroon" />


<br/>
<div className="album py-1">
        
            <div className="container">

                <div className="row">
               
                <div className="col-md-6">
                        
                        <div className="card-body">
                        <input type="text" class="form-control" placeholder="Search" name="title name" 
                        onChange ={(e) => {
                          setsearchTerm(e.target.value);
                        }}
                        />
                                <div className="d-flex justify-content-between align-items-center">
                                   
                                    
                            

                            </div>
                          
                    
                        </div>

                      
                    </div>
             
                    </div>
                  
                    </div>
                    </div>
<div className="album py-2">
        
        <div className="container">

            <div className="row">
            {videogallery.filter((val)=>{
      if (setsearchTerm === ""){
        return val;
      } else if (
        val.title.toLowerCase().includes(searchTerm.toLowerCase()) 
      
       
       
  
      ){
        return val;
      }
    }).slice(pagination.start, pagination.end).map((murshidabadmahilaurbanloan) => { return (
       
            <div className="col-md-4 mt-2" >
                        <div className=" mb-4">
                                  <ReactPlayer   width='350px' height='240px' url={murshidabadmahilaurbanloan.video}/>
                   
                            <div className="card-body">
                                
                                <h6 style={{color:"grey"}} className="card-text mt-2"> <b>{murshidabadmahilaurbanloan.title}</b></h6>
                              
                              
                               

                               
                    
                                <div className="d-flex justify-content-between align-items-center">
                              
                               
                              
                            </div>
                            </div>
                            </div>
                               
                            </div>
                                )})} 
                            </div>
                            {/* <PaginationOld showPerPage={showPerPage} 
                onPaginationChange={onPaginationChange}
                total={videoogallery.length}
                /> */}
                            </div>
                            </div>

</>
        
        );
    }
    
    export default YoutubeV;